import { useEffect, useState } from "react";
import React from "react";
import NotificationCards from "./notificationCards/NotificationCards";
import { sendNotification } from "../../../services/notification";

const NavNotificationBellIcon = () => {
  const [showNotifications, setShowNotifications] = useState(false); // State to control notification visibility
  const [isHovering, setIsHovering] = useState(false); // State to track hover

  let timer;

  // Handle hover on bell icon
  const handleMouseEnter = () => {
    clearTimeout(timer); // Clear any pending hide actions
    setIsHovering(true);
    setShowNotifications(true);
  };

  // Handle hover out from bell icon or modal
  const handleMouseLeave = () => {
    timer = setTimeout(() => {
      setIsHovering(false); // After delay, hide notifications if not hovering
      setShowNotifications(false);
    }, 0); // Notifications stay visible for 300ms after mouse leaves
  };

  const [notifications, setNotifications] = useState([]); // State to store notifications

  const getNoti = async () => {
    try {
      const res = await sendNotification(); // Fetch notifications
      setNotifications(res.items); // Set the notifications array
    } catch (error) {
      console.error("Failed to fetch notifications", error);
    }
  };

  useEffect(() => {
    getNoti();
  }, []);

  return (
    <div
      className="relative group"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* Notification Bell Icon */}
      <div className="navbar_dropdown-toggle w-dropdown-toggle">
        <div className="nav-icon">
          <div className="user notification" />
        </div>
      </div>

      {/* Notification Dropdown */}
      {(showNotifications || isHovering) && (
        <nav className="navbar_dropdown-list nav-width w-80">
          <div className="navbar_dropdown-content">
            <div className="navbar_dropdown-link-list hideScroll">
              {notifications.length > 0 ? (
                notifications.map((notification, index) => (
                  <NotificationCards key={index} notification={notification} />
                ))
              ) : (
                <p className="h-32 text-center pt-10 justify-center text-center text-stone-400 items-center">
                  Nothing brewing yet!
                </p>
              )}
            </div>
          </div>
        </nav>
      )}
    </div>
  );
};

export default NavNotificationBellIcon;
